import { render } from "./ProductChooserTest.vue?vue&type=template&id=4bfe59dc&scoped=true"
import script from "./ProductChooserTest.vue?vue&type=script&lang=js"
export * from "./ProductChooserTest.vue?vue&type=script&lang=js"

import "./ProductChooserTest.vue?vue&type=style&index=0&id=4bfe59dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bfe59dc"]])

export default __exports__